import { object, string } from 'yup';

export const validationSchema = object().shape({
  email: string().trim().customEmail('E-Mail-Adresse ist ungültig.').required('E-Mail-Adresse fehlt.'),
  password: string().required('Passwort fehlt.'),
});
